import React, { useMemo } from 'react';
import { LayoutContent, LayoutPage, FormRenderer, Form } from 'components';
import { useStoreValue } from 'store';
import { config } from '_config';
import { byCountry, initFormConfig, submitHandler } from 'utils';
import { useFormInitialValues, useSteps } from '../../hooks';

const FORM_ID = 'otherDetails';

function OtherDetails() {
  const [storeState] = useStoreValue();
  const initialValues = useFormInitialValues(FORM_ID);
  const formConfig = useMemo(() => initFormConfig(config.formConfigs[FORM_ID], storeState), [storeState]);
  const { goNext } = useSteps();

  const onSubmit = ({ values, errors }) => {
    function updateStoreAndRedirect() {
      const newAcquisition = {
        ...storeState.acquisition,
        otherDetails: { ...values },
      };

      goNext({
        storePatch: { acquisition: newAcquisition },
        dataLayerEventLabel: byCountry({
          AU: 'Next',
          NZ: 'Next',
        }),
      });
    }

    submitHandler({ submit: updateStoreAndRedirect, errors });
  };

  return (
    <LayoutPage noSessionTimeout>
      <Form
        id={FORM_ID}
        initialValues={initialValues}
        onSubmit={onSubmit}
        showSaveDraftButton
        saveDraftOnSubmit
        saveDraftOnSessionTimeout
      >
        {formData => {
          return (
            <LayoutContent>
              <FormRenderer config={formConfig} formData={formData} storeState={storeState} />
            </LayoutContent>
          );
        }}
      </Form>
    </LayoutPage>
  );
}

export { OtherDetails };
